import styled from 'styled-components';
import { deviceMax } from '../../../styles/MediaQuery';
import { arrowGreen } from '../../../styles/Variables';

export const TitleIcons = styled.div`
    display: none;

    @media ${deviceMax.mobileLm} {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        cursor: pointer;

        * {
            font-size: 2rem;
            color: ${arrowGreen};
            margin-right: 10px;
        }
    }
`;
